import { useSelector } from "react-redux";
import HealthIncNotificationToAddRelative from "../HealthIncNotificationToAddRelative/HealthIncNotificationToAddRelative"
import { checkHiringDateBetweenSixMonthesAndEightMonthes } from "../../../../libs/generalFunctions";

function HealthIncNotificationToAddRelativeMain() {
 
  const authMe = useSelector((state) => state.authme.data);   
  
  return (
    <>
    {
     ( authMe?.hiring_date && checkHiringDateBetweenSixMonthesAndEightMonthes(authMe.hiring_date) ) 
     ?
     (<HealthIncNotificationToAddRelative 
        notifText = {"تهانيا لقد أكملت 6 أشهر في الشركة و يحق لك التسجيل في التأمين الصحي ... يرجى ادخال بيانات (زوجك أو زوجتك) و أبنائك ليتم مراجعتهم من قبل الموارد البشرية"} 
        btnText = {"انتقال"}
        btnLink = {"/emp/h_insurance_personal_data"}
       />)
     :  
     (<HealthIncNotificationToAddRelative 
        notifText = {"يرجى ادخال بيانات (زوجك أو زوجتك) و أبنائك ليتم مراجعتهم من قبل الموارد البشرية"} 
        btnText = {"انتقال"}
        btnLink = {"/emp/h_insurance_personal_data"}
       />) 
    }
    </>
  )
}

export default HealthIncNotificationToAddRelativeMain